export function getRatingValues(rating) {
  if (rating <= 5) {
    return {
      color: '#4CAF50',
      label: 'Low',
      value: rating
    }
  } else if (rating <= 10) {
    return {
      color: '#FFC107',
      label: 'Medium',
      value: rating
    }
  } else if (rating <= 15) {
    return {
      color: '#F57C00',
      label: 'High',
      value: rating
    }
  } else {
    return {
      color: '#F44336',
      label: 'Extreme',
      value: rating
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/risks.js